@if (!isLoading) {
<div class="card">
  <div class="card-header">
    <div class="d-flex w-100 justify-content-between align-items-center">
      <span>Page Optimization Notes</span>
      @if (allOtherNotes.length > 0) {
      <button class="btn btn-sm btn-primary history-toggle" type="button" aria-expanded="false" data-toggle="collapse"
        href="#historyCollapse" role="button">
        <span class="if-closed">View All Notes</span>
        <span class="if-open">Recent Note Only</span>
      </button>
      } @else {
      <button class="btn btn-sm btn-primary history-toggle" type="button" disabled>View All Notes</button>
      }
    </div>
  </div>
  <div class="list-group list-group-flush">
    <div class="list-group-item py-3 bg-light-subtle border-bottom-0">
      @if (recentNote) {
      <div class="d-flex w-100 justify-content-between align-items-center mb-1">
        <strong class="text-primary">
          {{ recentNote.title }}
        </strong>
        <small class="text-muted small">
          <span class="badge pill bg-success">Recent</span> {{ recentNote.date | dateText: 'M/DD/YYYY h:mm a' }}
        </small>
      </div>
      <div class="mb-1">{{ recentNote.note }}</div>
      <small class="text-muted"><i>{{ recentNote.author }}</i></small>
      } @else {
        <div class="mb-1">No recent note found.</div>
      }
    </div>

    <div class="collapse hide" id="historyCollapse">
      <div style="max-height: 300px; overflow-y: auto;">
        @for(note of allOtherNotes; track note)
        {
        <div class="list-group-item py-2">
          <div class="d-flex w-100 justify-content-between align-items-center mb-1">
            <strong class="text-primary">
              {{ note.title }}
            </strong>
            <small class="text-muted small">
              {{ note.date | dateText: 'M/DD/YYYY h:mm a' }}
            </small>
          </div>
          <div class="mb-1">{{ note.note }}</div>
          <small class="text-muted"><i>{{ note.author }}</i></small>
        </div>
        }
      </div>
    </div>
  </div>
</div>
}